import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-5 py-20 text-center">
      <Compass size={52} className="text-navy/20" />
      <h1 className="mt-4 font-display text-5xl font-black tracking-tighter text-navy">404</h1>
      <p className="mt-2 text-lg font-semibold text-navy">Page not found</p>
      <p className="mt-1 text-muted-foreground">The page you're looking for doesn't exist or may have moved.</p>
      <div className="mt-6 flex gap-3">
        <Button asChild className="rounded-sm bg-brand text-white hover:bg-brand-hover"><Link to="/">Back home</Link></Button>
        <Button asChild variant="outline" className="rounded-sm"><Link to="/lots">Browse lots</Link></Button>
      </div>
    </div>
  );
}
